import { DEVICE_STATUS_TYPE } from '../../../model/device/device.model';

export const STATUS_ALERT = DEVICE_STATUS_TYPE.ALERT;
export const STATUS_ALERT_INPROGRESS = DEVICE_STATUS_TYPE.ALERT_INPROGRESS;
export const STATUS_OK = DEVICE_STATUS_TYPE.OK;
export const STATUS_OK_INPROGRESS = DEVICE_STATUS_TYPE.OK_INPROGRESS;
export const STATUS_INPROGRESS = DEVICE_STATUS_TYPE.INPROGRESS;
